/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 20.04.2016.
 */

import React, {Component, PropTypes} from 'react';
import DOMPurify from 'dompurify';

import _get from 'lodash/get';

class BannersSliderItem extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  _openAsset() {

    if (_get(this.props, 'item.asset.id', null)) this.props.onAssetSelect(this.props.item.asset);
  }

  _renderItem() {

    switch (this.props.item.type) {

      case 'asset':
        return (
          <a className="p hover radius" style={{backgroundImage: `url('${this.props.item.picture}')`}} onClick={this._openAsset.bind(this)}>
            <span className="block-note p">
              {this.props.item.text && <span className="adv-row" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.props.item.text) || '' }}></span>}
            </span>
          </a>
        );

      case 'url':
        return (

          <a href={this.props.item.url} target="_blank" rel="noopener noreferrer" className="p hover radius" style={{backgroundImage: `url('${this.props.item.picture}')`}}>
            <span className="block-note p">
              {this.props.item.text && <span className="adv-row" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.props.item.text) || '' }}></span>}
            </span>
          </a>
        );

      default:
        console.warn('Unsupported slider item data: ', this.props.item);
        return <div></div>
    }
  }

  render() {

    return (
      <li className="adv block-3 bg-black radius pointer" style={{float: 'left', listStyle: 'none'}}>
        {this._renderItem()}
      </li>
    );
  }
}

BannersSliderItem.propTypes = {
  item: PropTypes.object,
  onAssetSelect: PropTypes.func
};

export default BannersSliderItem;



// WEBPACK FOOTER //
// ./src/components/BannersSlider/banners-slider-item.js